<!-- TodoItem.svelte -->
<script>
    import { mmti_dict, pv } from "../store";
    export let todo;

    function update_mmti_dict(test_id, score) {
        ($mmti_dict)[test_id] = score;
        console.log($mmti_dict)
    }
    
    function onChange(event) {
        let score = event.currentTarget.value;
        let name = event.currentTarget.name;

        if (! (name in $mmti_dict)) {
            $pv += 1;
        }

        console.log(name);
        console.log(score);
        update_mmti_dict(name, score); 
    }

    let checked_score = $mmti_dict["mmti"+todo.id];
    console.log(checked_score);

</script>

<style lang="scss">

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.text_shake {
  animation: shake 0.5s;
}


/* Hide the browser's default radio button */
.radio input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* Create a custom radio button */
.checkmark {
  background-size: contain;
  position: absolute;
  top: 11px;
  left: 0;
  height: 30px;
  width: 30px;

  transition: background-image 0.3s;
}

.c1 {
  background-image: url("/unmarked_green.png");
  height: 30px;
  width: 30px;
}

.radio:hover input ~ .c1 {
  background-image: url("/marked_green.png");
}

.radio input:checked ~ .c1 {
  background-image: url("/marked_green.png");
}

.c2 {
  background-image: url("/unmarked_green.png");
  height: 25px;
  width: 25px;
  margin: 2.5px;
}

.radio:hover input ~ .c2 {
  background-image: url("/marked_green.png");
}

.radio input:checked ~ .c2 {
  background-image: url("/marked_green.png");
}

.c3 {
  background-image: url("/unmarked_grey.png");
  height: 20px;
  width: 20px;
  margin: 5px;
}

.radio:hover input ~ .c3 {
  background-image: url("/marked_grey.png");
}

.radio input:checked ~ .c3 {
  background-image: url("/marked_grey.png");
}


.c4 {
  background-image: url("/unmarked_red.png");
  height: 25px;
  width: 25px;
  margin: 2.5px;
}

.radio:hover input ~ .c4 {
  background-image: url("/marked_red.png");
}

.radio input:checked ~ .c4 {
  background-image: url("/marked_red.png");
}

.c5 {
  background-image: url("/unmarked_red.png");
  height: 30px;
  width: 30px;
}

.radio:hover input ~ .c5 {
  background-image: url("/marked_red.png");
}

.radio input:checked ~ .c5 {
  background-image: url("/marked_red.png");
}


.color-red {
  color: #ad1205;
}

.color-green {
  color: #36765a;
}
</style>

<h1 class="title is-6 {todo.textAni}" style="color: {todo.textColor}"><p>{todo.text}</p></h1>
<div class="control has-icons-left has-icons-right todo-item"
    class:todo-item--checked={todo.checked}>
<span class="color-green is-size-6 mr-3">동의</span>

<label class="radio">
  <input checked={checked_score==='2'} value="2" on:change={onChange} type="radio" name="mmti{todo.id}">
  <span class="checkmark c1"></span>
  <figure class="image container is-32x32"></figure>
</label>
<label class="radio">
  <input checked={checked_score==='1'} value="1" on:change={onChange} type="radio" name="mmti{todo.id}">
  <span class="checkmark c2"></span>
  <figure class="image container is-32x32"></figure>
</label>
<label class="radio">
  <input checked={checked_score==='0'} value="0" on:change={onChange} type="radio" name="mmti{todo.id}">
  <span class="checkmark c3"></span>
  <figure class="image container is-32x32"></figure>
</label>
<label class="radio">
  <input checked={checked_score==='-1'} value="-1" on:change={onChange} type="radio" name="mmti{todo.id}">
  <span class="checkmark c4"></span>
  <figure class="image container is-32x32"></figure>
</label>
<label class="radio">
  <input checked={checked_score==='-2'} value="-2" on:change={onChange} type="radio" name="mmti{todo.id}">
  <span class="checkmark c5"></span>
  <figure class="image container is-32x32"></figure>
  <!--<figure class="image container is-32x32"><img src="/unmarked_red.png"></figure>-->
</label>
<span class="color-red is-size-6 ml-3">미동의</span>
</div>

<figure class="image container" style="opacity: {todo.opacity};">
<img src="/line.png" style="height: 70px;">
</figure>


<!--
<div class="field">
  <div
    class="control has-icons-left has-icons-right todo-item"
    class:todo-item--checked={todo.checked}>
-->
<!--    <input
      class="input"
      type="text"
      bind:value={todo.text} />
  </div>
</div>
-->
